import { jsxs as b, jsx as o } from "react/jsx-runtime";
import { getStylesFromSelectors as T, createPureSelectors as K, createClassNameSelectors as Q } from "../../utils/classNameSelectors.js";
import "../../utils/sectionPreview.js";
import { forwardRef as U } from "react";
import f from "clsx";
import X from "next/link";
import { getButtonIcon as Y } from "./constants.js";
import '../../_assets/Button.DG3QbrGy.css';const Z = "_btn_1pn7p_44", E = "_disabled_1pn7p_67", M = "_reverse_1pn7p_83", I = "_icon_1pn7p_94", H = "_link_1pn7p_104", __ = "_linkGray_1pn7p_104", n_ = "_linkTerminal_1pn7p_104", l_ = "_noPadding_1pn7p_107", i_ = "_link_old_1pn7p_1848", e_ = "_linkGray_old_1pn7p_1849", p_ = "_linkTerminal_old_1pn7p_1850", m_ = "_link_new_1pn7p_1851", o_ = "_linkGray_new_1pn7p_1852", t_ = "_linkTerminal_new_1pn7p_1853", a_ = "_primary_old_1pn7p_2884", s_ = "_primary_new_1pn7p_2901", r_ = "_primaryV2_old_1pn7p_2917", c_ = "_primaryV2_new_1pn7p_2931", w_ = "_secondary_old_1pn7p_2945", x_ = "_secondary_new_1pn7p_2962", d_ = "_tertiary_old_1pn7p_2976", h_ = "_tertiary_new_1pn7p_2996", u_ = "_goGreen_new_1pn7p_3016", g_ = "_border_new_1pn7p_3032", y_ = "_outline_old_1pn7p_3056", S_ = "_outline_new_1pn7p_3078", k_ = "_outlineGray_old_1pn7p_3102", W_ = "_outlineGray_new_1pn7p_3124", G_ = "_outlineWhite_old_1pn7p_3148", b_ = "_outlineWhite_new_1pn7p_3165", T_ = "_linkWhite_new_1pn7p_3265", f_ = "_white_old_1pn7p_3275", z_ = "_white_new_1pn7p_3289", B_ = "_terminal_old_1pn7p_3303", N_ = "_terminal_new_1pn7p_3317", V_ = "_outlineTerminal_old_1pn7p_3331", C_ = "_outlineTerminal_new_1pn7p_3348", v_ = "_outlineWhiteBorder_old_1pn7p_3401", P_ = "_outlineWhiteBorder_new_1pn7p_3408", $_ = "_outlineGrey_old_1pn7p_3426", O_ = "_outlineGrey_new_1pn7p_3443", j_ = "_fuchsia_new_1pn7p_3467", L_ = "_agzPrimary_old_1pn7p_3482", A_ = "_agzPrimary_new_1pn7p_3497", F_ = "_agzWhite_old_1pn7p_3510", R_ = "_agzWhite_new_1pn7p_3525", q_ = "_fluid_1pn7p_3562", D_ = "_rounded_1pn7p_3566", J_ = "_noWrap_1pn7p_3570", _ = {
  btn: Z,
  disabled: E,
  reverse: M,
  "xxs-large": "_xxs-large_1pn7p_88",
  icon: I,
  "icon-left": "_icon-left_1pn7p_98",
  "icon-right": "_icon-right_1pn7p_101",
  link: H,
  linkGray: __,
  linkTerminal: n_,
  noPadding: l_,
  "with-icon-xxs-large": "_with-icon-xxs-large_1pn7p_111",
  "xxs-medium": "_xxs-medium_1pn7p_131",
  "with-icon-xxs-medium": "_with-icon-xxs-medium_1pn7p_154",
  "xxs-small": "_xxs-small_1pn7p_174",
  "with-icon-xxs-small": "_with-icon-xxs-small_1pn7p_197",
  "xxs-xSmall": "_xxs-xSmall_1pn7p_217",
  "with-icon-xxs-xSmall": "_with-icon-xxs-xSmall_1pn7p_240",
  "xs-large": "_xs-large_1pn7p_264",
  "with-icon-xs-large": "_with-icon-xs-large_1pn7p_287",
  "xs-medium": "_xs-medium_1pn7p_307",
  "with-icon-xs-medium": "_with-icon-xs-medium_1pn7p_330",
  "xs-small": "_xs-small_1pn7p_350",
  "with-icon-xs-small": "_with-icon-xs-small_1pn7p_373",
  "xs-xSmall": "_xs-xSmall_1pn7p_393",
  "with-icon-xs-xSmall": "_with-icon-xs-xSmall_1pn7p_416",
  "s-large": "_s-large_1pn7p_440",
  "with-icon-s-large": "_with-icon-s-large_1pn7p_463",
  "s-medium": "_s-medium_1pn7p_483",
  "with-icon-s-medium": "_with-icon-s-medium_1pn7p_506",
  "s-small": "_s-small_1pn7p_526",
  "with-icon-s-small": "_with-icon-s-small_1pn7p_549",
  "s-xSmall": "_s-xSmall_1pn7p_569",
  "with-icon-s-xSmall": "_with-icon-s-xSmall_1pn7p_592",
  "ssm-large": "_ssm-large_1pn7p_616",
  "with-icon-ssm-large": "_with-icon-ssm-large_1pn7p_639",
  "ssm-medium": "_ssm-medium_1pn7p_659",
  "with-icon-ssm-medium": "_with-icon-ssm-medium_1pn7p_682",
  "ssm-small": "_ssm-small_1pn7p_702",
  "with-icon-ssm-small": "_with-icon-ssm-small_1pn7p_725",
  "ssm-xSmall": "_ssm-xSmall_1pn7p_745",
  "with-icon-ssm-xSmall": "_with-icon-ssm-xSmall_1pn7p_768",
  "sm-large": "_sm-large_1pn7p_792",
  "with-icon-sm-large": "_with-icon-sm-large_1pn7p_815",
  "sm-medium": "_sm-medium_1pn7p_835",
  "with-icon-sm-medium": "_with-icon-sm-medium_1pn7p_858",
  "sm-small": "_sm-small_1pn7p_878",
  "with-icon-sm-small": "_with-icon-sm-small_1pn7p_901",
  "sm-xSmall": "_sm-xSmall_1pn7p_921",
  "with-icon-sm-xSmall": "_with-icon-sm-xSmall_1pn7p_944",
  "m-large": "_m-large_1pn7p_968",
  "with-icon-m-large": "_with-icon-m-large_1pn7p_991",
  "m-medium": "_m-medium_1pn7p_1011",
  "with-icon-m-medium": "_with-icon-m-medium_1pn7p_1034",
  "m-small": "_m-small_1pn7p_1054",
  "with-icon-m-small": "_with-icon-m-small_1pn7p_1077",
  "m-xSmall": "_m-xSmall_1pn7p_1097",
  "with-icon-m-xSmall": "_with-icon-m-xSmall_1pn7p_1120",
  "xm-large": "_xm-large_1pn7p_1144",
  "with-icon-xm-large": "_with-icon-xm-large_1pn7p_1167",
  "xm-medium": "_xm-medium_1pn7p_1187",
  "with-icon-xm-medium": "_with-icon-xm-medium_1pn7p_1210",
  "xm-small": "_xm-small_1pn7p_1230",
  "with-icon-xm-small": "_with-icon-xm-small_1pn7p_1253",
  "xm-xSmall": "_xm-xSmall_1pn7p_1273",
  "with-icon-xm-xSmall": "_with-icon-xm-xSmall_1pn7p_1296",
  "l-large": "_l-large_1pn7p_1320",
  "with-icon-l-large": "_with-icon-l-large_1pn7p_1343",
  "l-medium": "_l-medium_1pn7p_1363",
  "with-icon-l-medium": "_with-icon-l-medium_1pn7p_1386",
  "l-small": "_l-small_1pn7p_1406",
  "with-icon-l-small": "_with-icon-l-small_1pn7p_1429",
  "l-xSmall": "_l-xSmall_1pn7p_1449",
  "with-icon-l-xSmall": "_with-icon-l-xSmall_1pn7p_1472",
  "xl-large": "_xl-large_1pn7p_1496",
  "with-icon-xl-large": "_with-icon-xl-large_1pn7p_1519",
  "xl-medium": "_xl-medium_1pn7p_1539",
  "with-icon-xl-medium": "_with-icon-xl-medium_1pn7p_1562",
  "xl-small": "_xl-small_1pn7p_1582",
  "with-icon-xl-small": "_with-icon-xl-small_1pn7p_1605",
  "xl-xSmall": "_xl-xSmall_1pn7p_1625",
  "with-icon-xl-xSmall": "_with-icon-xl-xSmall_1pn7p_1648",
  "xxl-large": "_xxl-large_1pn7p_1672",
  "with-icon-xxl-large": "_with-icon-xxl-large_1pn7p_1695",
  "xxl-medium": "_xxl-medium_1pn7p_1715",
  "with-icon-xxl-medium": "_with-icon-xxl-medium_1pn7p_1738",
  "xxl-small": "_xxl-small_1pn7p_1758",
  "with-icon-xxl-small": "_with-icon-xxl-small_1pn7p_1781",
  "xxl-xSmall": "_xxl-xSmall_1pn7p_1801",
  "with-icon-xxl-xSmall": "_with-icon-xxl-xSmall_1pn7p_1824",
  link_old: i_,
  linkGray_old: e_,
  linkTerminal_old: p_,
  link_new: m_,
  linkGray_new: o_,
  linkTerminal_new: t_,
  primary_old: a_,
  primary_new: s_,
  primaryV2_old: r_,
  primaryV2_new: c_,
  secondary_old: w_,
  secondary_new: x_,
  tertiary_old: d_,
  tertiary_new: h_,
  goGreen_new: u_,
  border_new: g_,
  outline_old: y_,
  outline_new: S_,
  outlineGray_old: k_,
  outlineGray_new: W_,
  outlineWhite_old: G_,
  outlineWhite_new: b_,
  linkWhite_new: T_,
  white_old: f_,
  white_new: z_,
  terminal_old: B_,
  terminal_new: N_,
  outlineTerminal_old: V_,
  outlineTerminal_new: C_,
  outlineWhiteBorder_old: v_,
  outlineWhiteBorder_new: P_,
  outlineGrey_old: $_,
  outlineGrey_new: O_,
  fuchsia_new: j_,
  agzPrimary_old: L_,
  agzPrimary_new: A_,
  agzWhite_old: F_,
  agzWhite_new: R_,
  fluid: q_,
  rounded: D_,
  noWrap: J_,
  "slide-in-out": "_slide-in-out_1pn7p_1",
  "fade-in-out": "_fade-in-out_1pn7p_1"
}, K_ = U(
  ({
    className: z,
    style: s,
    iconClassName: B,
    component: r = "button",
    type: c = "button",
    variant: N = "primary",
    rounded: V = !1,
    size: w = "large",
    disabled: x,
    fluid: C = !1,
    icon: n,
    iconPosition: d = "left",
    onlyIcon: i = !1,
    onClick: v,
    href: t,
    children: p,
    externalHref: l,
    noWrap: P,
    noPadding: $,
    theme: O = "new",
    dataTestId: j,
    onTouchStart: L,
    onTouchEnd: A,
    onMouseEnter: h,
    onMouseLeave: u,
    ...e
  }, g) => {
    var W, G;
    const m = (W = t == null ? void 0 : t.toString()) == null ? void 0 : W.trim(), a = !!(m != null && m.length || (G = l == null ? void 0 : l.trim()) != null && G.length), F = a ? X : r, R = T(K(w, "small"), _), q = T(
      Q("with-icon", w, "small"),
      _
    ), y = f(
      z,
      _.btn,
      _[`${N}_${O}`],
      !i && R,
      i && q,
      C && _.fluid,
      V && _.rounded,
      x && _.disabled,
      // for Link
      {
        [_.reverse]: d === "right"
      },
      P && _.noWrap,
      $ && _.noPadding
    ), S = f(
      _.icon,
      {
        [_[`icon-${d}`]]: n && !i
      },
      B
    ), D = c === "span", k = typeof n == "string" ? Y(n) : n, J = typeof p == "string" ? `${p} (Opens in a new tab)` : "Opens in a new tab";
    return D ? /* @__PURE__ */ b("span", { className: y, style: s, children: [
      n && /* @__PURE__ */ o("span", { ref: g, className: S, ...e, children: k }),
      !i && /* @__PURE__ */ o("span", { children: p })
    ] }) : /* @__PURE__ */ b(
      F,
      {
        ref: g,
        type: !a && r === "button" ? c : null,
        href: m || l,
        className: y,
        disabled: x,
        target: l ? "_blank" : null,
        "aria-label": l || (e == null ? void 0 : e.target) === "_blank" ? J : null,
        onClick: v,
        "data-testid": j,
        ...h && { onMouseEnter: h },
        ...u && { onMouseLeave: u },
        ...!a && { onTouchStart: L, onTouchEnd: A },
        ...e,
        style: s,
        children: [
          n && /* @__PURE__ */ o("span", { className: S, style: { position: "relative" }, children: k }),
          !i && /* @__PURE__ */ o("span", { children: p })
        ]
      }
    );
  }
);
K_.displayName = "Button";
export {
  K_ as Button
};
